import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'offers',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const offers = require('./containers/OfferMasterContainer').default
      callback(null, offers)
    }, 'OfferMaster')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OfferMaster/index.js